import { AxiosEventBus } from '@shared/axios/axiosEventBus';

// Single app-wide Axios event bus. Shared by the providers (auth/localization
// emit and the error-handler / version-notifier subscriptions) and by useApi,
// so the API access needs no React provider.
export const axiosEventBus = new AxiosEventBus();
